import { useLocation } from '@remix-run/react';
import type { RSSFeedDataPodcast, RSSFeedDataYouTube, TRSSFeedElement } from '@shared/dream-components';
import type { RSSFeedDataPodcastShow } from '@shared/dream-components/src/types';

import useTypedLoaderData from '~/hooks/useUtils/useTypedLoaderData';
import type { RootLoaderData } from '~/root';
import type { PodcastShowEpisodePageLoaderData } from '~/routes/podcast/s/$showSlug/$episodeSlug';

export const useRssFeedData = (node: TRSSFeedElement, rssFeed: RSSFeedDataPodcast | RSSFeedDataYouTube | undefined) => {
  const { site } = useTypedLoaderData<RootLoaderData>();
  const location = useLocation();
  const publication = site.publication;
  const loaderData = useTypedLoaderData<PodcastShowEpisodePageLoaderData>();
  const isDynamicPodcastEpisodePage = location.pathname.startsWith('/podcast/s');
  const isStaticPodcastEpisodePage = location.pathname.startsWith('/podcast/') && !isDynamicPodcastEpisodePage;

  if (node.attrs.hasMigratedToCardStructure && node.attrs.source === 'beehiiv_podcast_show') {
    if (
      isDynamicPodcastEpisodePage ||
      (publication?.should_migrate_rss_feed_elements_and_page && isStaticPodcastEpisodePage)
    ) {
      return { episodes: loaderData?.podcastEpisode?.show?.recent_episodes } as RSSFeedDataPodcastShow;
    }

    return { episodes: node.attrs.selectedPodcastShowEpisodes ?? [] };
  }

  return rssFeed || (node.attrs.data as RSSFeedDataYouTube | RSSFeedDataPodcast);
};
